import { httpClient } from './httpClient';

// 利用規約とクーポン利用規約を取得 (一般ユーザー・管理者共通)
export const getActiveTerms = async () => {
  const response = await httpClient.get('/terms');
  return response.data;
};

// 更新用に利用規約を送信 (admin only)
export const updateTerms = async (termsData) => {
  const response = await httpClient.put('/terms/update', termsData);
  return response.data;
};